"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
/*
 * Defines the style of the button
 */
var AddinButtonStyle;
(function (AddinButtonStyle) {
    // No style (default)
    AddinButtonStyle[AddinButtonStyle["None"] = 0] = "None";
    // The button represents an "add" operation
    AddinButtonStyle[AddinButtonStyle["Add"] = 1] = "Add";
    // The button represents an "edit" operation
    AddinButtonStyle[AddinButtonStyle["Edit"] = 2] = "Edit";
    // The button represents a "delete" operation
    AddinButtonStyle[AddinButtonStyle["Delete"] = 3] = "Delete";
})(AddinButtonStyle = exports.AddinButtonStyle || (exports.AddinButtonStyle = {}));
//# sourceMappingURL=addin-button-style.js.map